import React, { useState, useEffect } from 'react';
import Select from "react-select";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDateTimePicker } from "@mui/x-date-pickers/MobileDateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/en";
import { StyledEngineProvider } from "@mui/material/styles";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import loader from "../../assets/Images/loader.gif";



const BusinessMeetings = () => {
    // Using Dayjs for dateTime
    const [dateTime, setDateTime] = useState(dayjs());
    const [mode, setMode] = useState(null);
    const [remarks, setRemarks] = useState("");
    const [status, setStatus] = useState(null);
    const [met, setMet] = useState(null);
    const [selectedDateTime, setSelectedDateTime] = useState(null);
    const [getMeetingData, setMeetingData] = useState([]);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const OppId = searchParams.get("OppId");
    const leadId = searchParams.get("LeadId");
    const ContactId = searchParams.get("ContactId");
    const [position, setPosition] = useState({ latitude: null, longitude: null });
    const [loaders, setLoaders] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isDateTimeLocked, setIsDateTimeLocked] = useState(false);

    const [leadStatus, setLeadStatus] = useState("");
    const [contactStatus, setContactStatus] = useState("");
    const [oppStatus, setOppStatus] = useState("");


    const handleDateTimeChange = (dateTime) => {
        if (!isDateTimeLocked) {
            setSelectedDateTime(dateTime);
            getLocation();
        }
    };
    // Options for the select fields
    const modeOptions = [
        { value: "0", label: "Virtual" },
        { value: "1", label: "In-Person" },
    ];

    const statusOptions = [
        { value: "0", label: "Open" },
        { value: "1", label: "Completed" },
        { value: "2", label: "Cancelled" },

    ];

    const metOptions = [
        { value: "0", label: "Owner" },
        { value: "1", label: "Manager" },
        { value: "2", label: "Caretaker" },
        { value: "3", label: "Unavailable" },
    ];



    // const getLocation = () => {
    //     if ("geolocation" in navigator) {
    //         navigator.geolocation.getCurrentPosition(function (position) {
    //             setPosition({
    //                 latitude: position.coords.latitude,
    //                 longitude: position.coords.longitude,
    //                 message: "Location Captured",
    //             });
    //         });
    //     } else {
    //         // console.log("Geolocation is not available in your browser.");
    //         toast.warning("location is not available in your browser.", {
    //             position: toast.POSITION.BOTTOM_CENTER,
    //             autoClose: 1500,
    //         });
    //     }
    // };


    const getLocation = () => {
        // Check if served over HTTPS (geolocation doesn't work over HTTP in production)
        if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost') {
            toast.error("Location access requires HTTPS. Please use a secure connection.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
            return;
        }

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    setPosition({
                        latitude: pos.coords.latitude,
                        longitude: pos.coords.longitude,
                        message: "Location Captured",
                    });
                },
                (error) => {
                    console.error("Geolocation error:", error);
                    toast.error("Unable to retrieve location. Please check browser permissions.", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                }
            );
        } else {
            toast.warning("Geolocation is not supported by this browser.", {
                position: toast.POSITION.BOTTOM_CENTER,
                autoClose: 2000,
            });
        }
    };

    useEffect(() => {
        if (position.latitude && position.longitude) {
            // console.log("Updated position:", position);
        }
    }, [position]);

    useEffect(() => {
        getLocation();
    }, []);


    const hasOpenMeeting =
        getMeetingData && getMeetingData.some((item) => item.MeetingStatus === "Open");
    const handleSubmit = async (e) => {

        e.preventDefault();
        // Use selectedDateTime if available; otherwise fallback to dateTime
        const formattedDateTime = selectedDateTime
            ? selectedDateTime.format("YYYY-MM-DD HH:mm:ss")
            : dateTime.format("YYYY-MM-DD HH:mm:ss");

        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: "addMeeting",
            ContactID: ContactId,
            LeadID: leadId,
            OppId: OppId,
            DateTime: formattedDateTime,
            Mode: mode?.value || "",
            Remarks: remarks,
            status: status?.value || "",
            metWithWhom: met?.value || "",
            Latitude: position.latitude ? `${position.latitude}` : "",
            Longitude: position.longitude ? `${position.longitude}` : "",
            password: sessionStorage.getItem("password"),
            userName: sessionStorage.getItem("userName"),
        };

        try {
            setLoading(true);

            const response = await fetch(process.env.REACT_APP_API_URL, { // Update with your API endpoint
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            // console.log("API Response:", result);
            if (result.Status === "Success") {
                {
                    toast.success("Meeting Created Successfully", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    if (OppId) {
                        navigate("/businessOpportunity");
                    } else if (leadId) {
                        navigate("/businessLead");
                    } else if (ContactId) {
                        navigate("/contactManagement");
                    }
                }
            } else {
                toast.warning(result.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            // Optionally, update meeting history by refetching or adding the new record locally
        } catch (error) {
            console.error("Error adding meeting:", error);
        }
        setLoading(false);

    };
    const handleUpdate = async () => {
        getLocation();

        const formattedDateTime = selectedDateTime
            ? selectedDateTime.format("YYYY-MM-DD HH:mm:ss")
            : dateTime.format("YYYY-MM-DD HH:mm:ss");

        const payload = {
            Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
            Action: "updateMeeting",
            ContactID: ContactId,
            LeadID: leadId,
            OppId: OppId,
            DateTime: formattedDateTime,
            Mode: mode?.value || "",
            Remarks: remarks,
            status: status?.value || "",
            metWithWhom: met?.value || "",
            Latitude: position.latitude ? `${position.latitude}` : "",
            Longitude: position.longitude ? `${position.longitude}` : "",
            password: sessionStorage.getItem("password"),
            userName: sessionStorage.getItem("userName"),
        };

        try {
            setLoading(true);

            const response = await fetch(process.env.REACT_APP_API_URL, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });
            const result = await response.json();
            // console.log("Update Meeting API Response:", result);
            if (result.Status === "Success") {
                {
                    toast.success("Meeting Updated Successfully", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 1500,
                    });
                    if (OppId) {
                        navigate("/businessOpportunity");
                    } else if (leadId) {
                        navigate("/businessLead");
                    } else if (ContactId) {
                        navigate("/contactManagement");
                    }
                }
            } else {
                toast.warning(result.Response.Message, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 1500,
                });
            }
            // Optionally refresh meeting history after a successful update
        } catch (error) {
            console.error("Error updating meeting:", error);
        }
        setLoading(false);

    };

    //   const handleIconClick = (formId) => {
    //     setActiveForm((prevActiveForm) => (prevActiveForm === formId ? null : formId));
    //   };

    useEffect(() => {
        const fetchMeetingData = async () => {
            try {
                const response = await fetch(process.env.REACT_APP_API_URL, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                        Action: "getMeeting",
                        ContactID: ContactId,
                        LeadID: leadId,
                        OppId: OppId,
                        password: sessionStorage.getItem("password"),
                        userName: sessionStorage.getItem("userName"),
                    }),
                });
                const result = await response.json();
                // Check if the API call was successful and update the meeting data
                if (
                    result.Status === "Success" &&
                    result.Response &&
                    result.Response.Data
                ) {
                    const meetingData = result.Response.Data;
                    setMeetingData(meetingData);

                    // Find the open meeting from the response data
                    const openMeeting = meetingData.find(
                        (item) => item.MeetingStatus === "Open"
                    );
                    if (openMeeting) {
                        // Populate the form with the open meeting details
                        setSelectedDateTime(dayjs(openMeeting.MeetingDateandTime));
                        // Find the corresponding option objects based on labels
                        setMode(modeOptions.find(opt => opt.label === openMeeting.MeetingMode));
                        setStatus(statusOptions.find(opt => opt.label === openMeeting.MeetingStatus));
                        setMet(metOptions.find(opt => opt.label === openMeeting.MetWithWhom));
                        setRemarks(openMeeting.Remarks);
                        setIsDateTimeLocked(true);

                    }
                }
            } catch (error) {
                console.error("Error fetching meeting data:", error);
            }
        };

        fetchMeetingData();
    }, []);



    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getLeads",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    ContactId: ContactId ? ContactId : "",
                    LeadId: leadId ? leadId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName')
                }
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                // console.log("getLeads", data);

                if (data.Status == "Success") {
                    // console.log("getLeads", data);

                    if (data.Response[0]?.Status == 1 || data.Response[0]?.Status == 2) {
                        toast.warning("Cannot Create meeting as Lead is already Qualified/Disqualified", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 2000,
                        });
                        navigate("/businessLead");
                    }

                }

            } catch (error) {
                //console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();

    }, [leadId]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getopportunity",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    LeadId: "",
                    OppId: OppId ? OppId : "",
                    password: sessionStorage.getItem('password'),
                    userName: sessionStorage.getItem('userName'),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });

                const responsedata = await response.json();
                const responseData = responsedata?.Response?.Data?.[0];
                // console.log(responseData?.ProductSegment, responseData?.Building_BuildingStatus, responseData?.Redunancy, responseData?.InfraFlag);

                // console.log("getLeads1" ,responsedata1);
                if (responsedata?.Status === "Success" && responseData) {
                    // console.log("responsedata", responseData.Status);

                    if (responseData.Status !== "Open") {
                        toast.warning("Cannot Create meeting as Opportunity is already Won/Lost", {
                            position: toast.POSITION.BOTTOM_CENTER,
                            autoClose: 2000,
                        });
                        navigate("/businessOpportunity");
                    }


                } else {
                    console.error("Error fetching opportunity data:", responseData?.Message);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const requestBody = {
                    Action: "getContactIndustry",
                    Authkey: "ac7b51de9d888e1458dd53d8aJAN3ba6f",
                    contactID: ContactId,
                    password: sessionStorage.getItem("password"),
                    userName: sessionStorage.getItem("userName"),
                };
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(requestBody),
                });
                const data = await response.json();
                // const data = await response.json();
                const apiData = data.Response.Data[0];

                // console.log(apiData);

                if (apiData.StatusReason == "Lead Created/Closed" || apiData.StatusReason == "Disqualified") {
                    toast.warning("Cannot Create meeting as Contact is already Qualified/Disqualified", {
                        position: toast.POSITION.BOTTOM_CENTER,
                        autoClose: 2000,
                    });
                    navigate("/contactManagement");
                }


            } catch (error) {
                //console.error("Error fetching data:", error);
                toast.warning(error, {
                    position: toast.POSITION.BOTTOM_CENTER,
                    autoClose: 500,
                });

            } finally {

            }
        };
        fetchData();
    }, [ContactId]);


    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     // Format dateTime using dayjs's format method
    //     const formData = {
    //         dateTime: dateTime.format("YYYY-MM-DD HH:mm"),
    //         mode: mode?.value,
    //         remarks,
    //         status: status?.value,
    //         met: met?.value,
    //     };
    //     console.log("Form Data:", formData);
    //     // Add submission logic here...
    // };

    const [activeForm, setActiveForm] = useState("form1");
    const handleIconClick = (formId) => {
        setActiveForm((prevActiveForm) => (prevActiveForm === formId ? null : formId));
    };

    const style = {
        control: (base) => ({
            ...base,
            border: 0,
            boxShadow: "none",
            backgroundColor: "transparent",
            color: "black",
        }),
        inputFocused: {
            boxShadow: "none",
            fontSize: "14px",
        },
    };
    const navigate = useNavigate();
    const redirectBack = () => {
        if (OppId) {
            navigate("/businessOpportunity");
        } else if (leadId) {
            navigate("/businessLead");
        } else if (ContactId) {
            navigate("/contactManagement");
        }
    };





    return (
        <>
            <div className="container-fluid text-light Header-style header">
                {/* Header */}
                <div className="p-3">

                    <span style={{ cursor: "pointer" }}
                        onClick={redirectBack}

                    >

                        <i className="fa-solid fa-arrow-left-long"></i>
                    </span>
                    <span className="p-1 m-3">Schedule Appointment</span>

                </div>

            </div>

            {/* Meeting toggle */}
            <div className='container-fluid form-container'>

                <div className="Installation-toggle mt-3" onClick={() => handleIconClick("form1")}>
                    <span className="toggle-text">Meeting </span>
                    <span className="float-end">
                        <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                    </span>
                </div>
                {loading ? (
                    <div className="loader-wrapper">
                        <div className="loader">
                            <img src={loader} alt="loading...."></img>
                        </div>
                    </div>
                ) : (
                    <>

                        {activeForm === "form1" && (
                            <div className="container shadow mb-3 bg-body rounded mt-4" id="form1">
                                <form className="Installation-form p-2" >
                                    {/* Date and Time Field using MobileDateTimePicker */}
                                    {/* <div className="input-box form-floating mb-3">
                            <label className="select-search-label mt-1">Date and Time*</label>

                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <MobileDateTimePicker
                                    value={dateTime}
                                    onChange={(newValue) => setDateTime(newValue)}
                                    minDateTime={dayjs()}
                                    styles={style}

                                    renderInput={(params) => (
                                        <input
                                            {...params}
                                            type="text"
                                            className="form-control input-text form-control-sm mt-1"
                                        />
                                    )}
                                />
                            </LocalizationProvider>
                        </div> */}
                                    <div>
                                        <label className="select-search-label mt-1">Date and Time*</label>
                                        <StyledEngineProvider>
                                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                <DemoContainer components={["MobileDateTimePicker"]}>
                                                    <MobileDateTimePicker
                                                        value={selectedDateTime}
                                                        onChange={handleDateTimeChange}
                                                        disablePast
                                                        disabled={isDateTimeLocked}  // Locked if open meeting exists

                                                    />
                                                </DemoContainer>
                                            </LocalizationProvider>
                                        </StyledEngineProvider>
                                    </div>

                                    {/* Mode Field */}
                                    <div className="search-building" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Mode*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1 custom-select"
                                            options={modeOptions}
                                            value={mode}
                                            onChange={setMode}
                                            styles={style}
                                            placeholder="Select Mode"
                                            isSearchable={false}
                                        />
                                    </div>


                                    {/* Status Field */}
                                    <div className="search-building" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Status*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1 custom-select"
                                            options={statusOptions}
                                            value={status}
                                            onChange={setStatus}
                                            styles={style}
                                            placeholder="Select Status"
                                            isSearchable={false}
                                        />
                                    </div>

                                    {/* Met Field */}
                                    <div className="search-building" style={{ position: "relative" }}>
                                        <label className="select-search-label mt-1">Person Met*</label>
                                        <Select
                                            className="basic-single form-control form-control-sm p-1 custom-select"
                                            options={metOptions}
                                            value={met}
                                            onChange={setMet}
                                            styles={style}
                                            placeholder="Select Person Met"
                                            isSearchable={false}
                                        />
                                    </div>

                                    {/* Remarks Field */}
                                    <div className="input-box form-floating mb-3">
                                        <textarea
                                            id="remarks"
                                            name="remarks"
                                            className="form-control input-text"
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                            placeholder="Enter remarks"
                                            rows="3"
                                        ></textarea>
                                        <label htmlFor="remarks" className="mt-2">
                                            Remarks
                                        </label>
                                    </div>

                                    <div className="text-center mt-5 mb-5">
                                        {!hasOpenMeeting && (

                                            <button type="button" className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                                                onClick={handleSubmit}


                                            >
                                                Save
                                            </button>
                                        )}
                                        {hasOpenMeeting && (
                                            <button
                                                type="button"
                                                onClick={handleUpdate}
                                                className="btn text-light bg-dark mx-auto rounded-pill submit-btn"
                                            >
                                                Update
                                            </button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        )}

                        <div
                            className="Remarks-toggle mt-3"
                            onClick={() => handleIconClick("form8")}
                        >
                            <span className="toggle-text">Meeting History</span>
                            <span className=" float-end">
                                <i className="fa-solid fa-angle-down fa-lg text-dark"></i>
                            </span>
                        </div>

                        {activeForm === "form8" && (
                            <div className="container shadow bg-body rounded mt-4 p-4" id="form8">


                                <div className="row row-cols-1 row-cols-sm-1 row-cols-md-2 row-cols-lg-3">
                                    {getMeetingData?.length > 0 ? (
                                        getMeetingData.map((data, index) => (
                                            <>
                                                <div className="col " key={index}>
                                                    <div className="card mb-3" >
                                                        <div className="m-2 card-data" style={{ display: "inline-flex" }}>
                                                            <div>
                                                                {/* <strong>
                                                                Meeting Schedule: {data.MeetingDateandTime}
                                                            </strong>
                                                            <div className='mt-1'>Meeting Mode: {data.MeetingMode}</div>
                                                            <div className='mt-1'>Meeting Status: {data.MeetingStatus}</div>
                                                            <div className='mt-1'>Met With Whom: {data.MetWithWhom}</div>
                                                            <div className='mt-1'>Remarks: {data.Remarks}</div> */}
                                                                <p className="opportunity-card-title">Meeting Schedule: {data.MeetingDateandTime}</p>
                                                                <p className="opportunity-card-text">Meeting Mode: {data.MeetingMode}</p>
                                                                <p className="opportunity-card-text">Meeting Status: {data.MeetingStatus}</p>
                                                                <p className="opportunity-card-text">Met With Whom: {data.MetWithWhom}</p>
                                                                <p className="opportunity-card-text">Remarks: {data.Remarks}</p>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        ))
                                    ) : (
                                        <div>No Meetings records found.</div>
                                    )}
                                </div>


                            </div>
                        )}
                    </>

                )}

            </div>
        </>
    );
};

export default BusinessMeetings;
